// EkycDataCapture;
// EkycDataLivenessCheck;

import {ooredooSelect} from "../../ods/V2/Elements/ooredoo-select";
import {EkycDataCapture} from "./ekycDataCapture";
import {EkycDataLivenessCheck} from "./ekycDataLivenessCheck";
import {errorAlert, fixAlertContentHeight, successAlert} from "../../ods/V2/Components/jquery-confirm";
import {makeSelect} from "../../oss/customSelect";
import {isMobile} from "../../oss/site";

const onAlertBeforeOpen = function () {
    const me = this;

    me.$el.addClass('jconfirm-ooredoo');
    if (me.hideIcon){
        me.$icon.hide();
    }
    if (typeof me.jqueryConfirmClasses === 'string' && me.jqueryConfirmClasses.length){
        me.$el.addClass(me.jqueryConfirmClasses);
    }

    me.$content.children().wrap("<div class='jconfirm-content__inner'></div>");
    if (me.$btnc.find('button').length) {
        me.$btnc.addClass('jconfirm-buttons--' + me.$btnc.find('button').length)
    }
    if (me.hideButtons === true) {
        $.each(me.buttons, function (aName, aBtn) {
            aBtn.hide();
        });

    }

    if (typeof me.onBeforeOpenCallback === 'function'){
        me.onBeforeOpenCallback();
    }

    console.log('me.$content',me);
    console.log('me.$content',me.$content);
    setTimeout(function () {
        let h = parseFloat(me.$content.css('height'))
        me.$content.css('minHeight', h + 20);
    }, 100)

};

export default class EkycJourney {

    constructor(formConfig, params) {
        this.formConfig = formConfig;
        this.params = params;
        this._alertDataCapture = null;
        this._alertLivenessCheck = null;
        this.disable_liveness_check = params.disable_liveness_check === true;
        this.hasListeners = false;
        this._uniqueId = 0;

        this.photoCaptureBaseUniqueCode = null;
        this.dataCaptureBaseUniqueCode = null;

        this.dataCaptureState = {
            status: false,
            data_captrue: {},
            liveness_check: {},
            formConfig: {},
        };

        this.getUniqueId = this.getUniqueId.bind(this);
        this.initListeners = this.initListeners.bind(this);
        this.startJourney = this.startJourney.bind(this);
        this.chooseIdType = this.chooseIdType.bind(this);
        this.startDataCapture = this.startDataCapture.bind(this);
        this.startLivenessCheck = this.startLivenessCheck.bind(this);
        this.onDataCaptureUpdated = this.onDataCaptureUpdated.bind(this);
        this.onLivenessCheckUpdated = this.onLivenessCheckUpdated.bind(this);
        this.onDataCaptureFailed = this.onDataCaptureFailed.bind(this);
        this.onLivenessCheckFailed = this.onLivenessCheckFailed.bind(this);

    }


    getUniqueId() {
        this._uniqueId = window._ooredoo_ekyc_uuid || 0;
        if (isNaN(Number(this._uniqueId))) {
            this._uniqueId = 0;
        }

        this._uniqueId += 1;
        window._ooredoo_ekyc_uuid = this._uniqueId;

        return this._uniqueId;
    }

    async startJourney() {
        console.log('startJourney')
        await this.chooseIdType();

        const formIdType = this.params.form.find('[name="identity_type"]');
        if (formIdType.length) {
            let val = 'id_card';

            if (this.formConfig.data_capture.idType == 'Passport') {
                val = 'passport';
            }
            formIdType.val(val);
            formIdType.trigger('change');

            if (this.params.btn.attr('data-ekyc_app') === 'oss') {
                formIdType.find('[data-value="id_card"]');
                formIdType.closest('.custom-select-wrapper').find(`[data-value="${val}"]`).trigger('click');

            } else {
                formIdType.closest('.ooredoo-ods-select-wrapper').find(`[data-ooredoo_value="${val}"]`).trigger('click');
            }

        }


        console.log('chooseIdType', this.formConfig)
        this.initListeners();

        this.startDataCapture();

    }

    initListeners() {
        if (this.hasListeners) {
            return;
        }

        const journeyFactory = this;

        this.hasListeners = true;
        const eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
        const eventer = window[eventMethod];
        const messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";

        console.log('messageEvent', messageEvent, eventMethod, eventer);

        const listnerFunction = function (e) {

            var key = e.message ? "message" : "data";
            var data = e[key] || false;

            if (data) {
                if (data.type === "ekyc_DC_Response") {
                    console.log('data.type', data.type, data)

                    journeyFactory.dataCaptureState.status = true;
                    journeyFactory.dataCaptureState.data_captrue = data.data;

                    journeyFactory.onDataCaptureUpdated();

                } else if (data.type === "ekyc_PC_Response") {
                    console.log('data.type', data.type, data)
                    journeyFactory.dataCaptureState.liveness_check = data.data;
                    journeyFactory.onLivenessCheckUpdated();

                }

            }

            // window.removeEventListener(messageEvent, listnerFunction, false);

        };

        // Listen to message from child window
        eventer(messageEvent, listnerFunction, false);
    }


    chooseIdType() {

        const journeyFactory = this;


        const formIdTypeVal = this.params.form.find('[name="identity_type"]').val();
        console.log('formIdTypeVal',formIdTypeVal);

        return new Promise((resolve, reject) => {

            let formFields = this.params.wrapper.find('template.ooredoo-ekyc__fields').html().trim();

            $.alert({
                content: formFields,
                columnClass: 'column is-6',
                iconHtml: null,
                icon: 'icon-oss-id',
                // hideIcon: true,
                jqueryConfirmClasses: 'ekyc-modal ekyc-modal-data-capture',
                onOpenBefore:onAlertBeforeOpen,
                onBeforeOpenCallback: function () {
                    const me = this;
                    const fixAlertHeight = function (selectRoot) {

                        if (selectRoot.find('.ooredoo-ods-select').hasClass('is-opened')) {
                            let h = selectRoot.find('.ooredoo-ods-select__items').height();
                            h += selectRoot.find('.ooredoo-ods-select__selected-item').height();
                            me.$content.css('height', me.$content.height() + h);

                        } else {
                            me.$content.css('height', '');
                        }

                    }

                    $.each(me.$content.find('.ods-select'), function (idx, el) {
                        $(el).on('odsSelect:opened', function (e) {
                            const selectRoot = $(this).closest('.ooredoo-ods-select-wrapper');
                            fixAlertHeight(selectRoot);
                        });

                        $(el).on('odsSelect:closed', function (e) {
                            const selectRoot = $(this).closest('.ooredoo-ods-select-wrapper');
                            fixAlertHeight(selectRoot);
                        });

                        if (journeyFactory.params.btn.attr('data-ekyc_app') === 'oss') {
                            if (formIdTypeVal && formIdTypeVal === 'passport'){
                                $(el).val('Passport');
                            }
                            makeSelect($(el));
                        } else {
                            ooredooSelect($(el));
                        }

                    });

                },
                onContentReady: function () {

                },
                onClose: function () {
                    reject();
                },

                buttons: {

                    continue: {
                        text: window.application.ods.js_trans.continue,
                        action: function () {
                            const me = this;
                            const idType = me.$content.find('select#ekyc-field-id-type').val();

                            if (!idType || !idType.toString().length) {
                                return false;
                            }

                            journeyFactory.formConfig.data_capture.nationality = 'foreigner';

                            if (idType === 'Palestinian National ID') {
                                journeyFactory.formConfig.data_capture.nationality = 'Palestinian'
                            }
                            journeyFactory.formConfig.data_capture.idType = idType;

                            resolve();
                        }
                    },

                    cancel: {
                        text: window.application.ods.js_trans.cancel,
                    },

                }

            })
        });

    }

    startDataCapture() {
        console.log('startDataCapture')
        const journeyFactory = this;

        journeyFactory.getUniqueId();

        if (!journeyFactory.dataCaptureBaseUniqueCode) {
            journeyFactory.dataCaptureBaseUniqueCode = journeyFactory.formConfig.data_capture.uniqueCode;
        }

        journeyFactory.formConfig.data_capture.uniqueCode = `${journeyFactory.dataCaptureBaseUniqueCode}${journeyFactory._uniqueId}`;


        this._alertDataCapture = $.alert({
            content: '',
            columnClass: 'column is-12',
            iconHtml: null,
            icon: null,
            hideIcon: true,
            jqueryConfirmClasses: 'ekyc-modal ekyc-modal-data-capture',
            onOpenBefore:onAlertBeforeOpen,
            onBeforeOpenCallback: function () {
                const me = this;
                me.showLoading();
            },
            onContentReady: function () {

                const req = EkycDataCapture(journeyFactory.formConfig.data_capture);

                req.then((response) => {
                    const me = this;

                    const apiUrl = response.apiUrl;

                    const iframe = document.createElement('iframe');
                    // iframe.scrolling = "no";
                    iframe.allow = "camera; microphone; geolocation";
                    iframe.style.width = '100%';
                    iframe.style.height = '600px';

                    me.setContent(iframe);

                    if (isMobile()) {
                        me.$content.prepend(`<div class="mb-5">${window.application.oss.translations.ekyc.data_capture_message_desc}</div>`)
                    } else {
                        me.$content.append(`<div class="mb-5">${window.application.oss.translations.ekyc.data_capture_message_desc}</div>`)
                    }
                    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

                    iframeDoc.open();
                    iframeDoc.write(`<base href="${apiUrl}">${response.html}`);
                    iframeDoc.close();

                    iframeDoc.onreadystatechange = function () {
                        if (iframeDoc.readyState === 'complete') {
                            me.hideLoading();

                            // setTimeout(function () {
                            //     console.log('redirect')
                            //     iframe.src = 'https://simsaleuat.ooredoo.ps/ods/IslWebAPI/ekyc/dc?uniqueCode=ods744be4c497f488571e79960383e73a80&responseCode=200&responseDesc=The%20trx%20is%20success%20on%20the%20server&trxId=8757F349317C499A856152FF9240F0DA';
                            // }, 4000)

                        }

                    }

                }).catch((err) => {

                    console.error('err', err);
                    // journeyConfig.reject(err);

                    // JourneyAlert.close();

                    journeyFactory.onDataCaptureFailed(err);

                    return err;
                });
            },
            onClose: function () {
                console.log('dataCapture@onClose');
            },

            buttons: {
                cancel: {
                    text: window.application.ods.js_trans.cancel,
                },
            }

        });

    }

    async startLivenessCheck() {
        console.log('startLivenessCheck')
        const journeyFactory = this;
        if (journeyFactory._alertLivenessCheck) {
            journeyFactory._alertLivenessCheck.close();
            journeyFactory._alertLivenessCheck = null;
        }

        const confirmNextStep = async () => {
            return new Promise((resolve, reject) => {
                $.alert({
                    content: window.application.oss.translations.ekyc.liveness_check_message_desc,
                    columnClass: 'column is-6',
                    icon: 'icon-Icon-011',
                    closeIcon: false,
                    jqueryConfirmClasses: 'ekyc-modal ekyc-modal-data-capture',
                    onClose: function () {

                    },

                    buttons: {
                        cancel: {
                            text: window.application.ods.js_trans.cancel,
                            action: function () {
                                reject();
                            },
                        },
                        continue: {
                            text: window.application.ods.js_trans.continue,
                            action: function () {
                                resolve();
                            },
                        },

                    }

                });

            });
        }

        await confirmNextStep();
        console.log('confirmed')

        journeyFactory._alertLivenessCheck = $.alert({
            content: '',
            columnClass: 'column is-12',
            iconHtml: null,
            icon: null,
            hideIcon: true,
            jqueryConfirmClasses: 'ekyc-modal ekyc-modal-data-capture',

            onOpenBefore:onAlertBeforeOpen,
            onBeforeOpenCallback: function () {
                console.log('onBeforeOpenCallback')
                const me = this;
                me.showLoading();
            },

            onContentReady: function () {
                const me = this;

                const formConfig = journeyFactory.formConfig;
                console.log('journeyFactory.dataCaptureState',journeyFactory.dataCaptureState);

                if(
                     typeof journeyFactory.dataCaptureState !== 'undefined'
                    && typeof journeyFactory.dataCaptureState.data_captrue !== 'undefined'
                    && typeof journeyFactory.dataCaptureState.data_captrue.file !== 'undefined'
                    && typeof journeyFactory.dataCaptureState.data_captrue.file.url !== 'undefined'
                ){
                    formConfig.photo_capture.file_path = journeyFactory.dataCaptureState.data_captrue.file.url;

                }

                let ocrId = journeyFactory.dataCaptureState.data_captrue.ocr_id;

                if (!ocrId) {
                    ocrId = 'oss5db060f03613a394d5603df71605a2f41';
                }

                formConfig.photo_capture.returnUrl = formConfig.photo_capture.returnUrl.replace(/__OCR__ID__/g, ocrId);


                console.log('formConfig', formConfig)
                const livenessRequest = EkycDataLivenessCheck(formConfig.photo_capture);

                livenessRequest
                    .then((response) => {

                        console.log('startEkycDataLivenessJourney');

                        const apiUrl = response.apiUrl;

                        const iframe = document.createElement('iframe');
                        // iframe.scrolling = "no";

                        iframe.allow = "camera; microphone; geolocation";
                        iframe.style.width = '100%';
                        iframe.style.height = '600px';

                        me.setContent(iframe);

                        const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

                        iframeDoc.open();
                        iframeDoc.write(`<base href="${apiUrl}">${response.html}`);
                        iframeDoc.close();

                        iframeDoc.onreadystatechange = function () {
                            if (iframeDoc.readyState === 'complete') {
                                me.hideLoading();

                                // setTimeout(function () {
                                //     console.log('redirect')
                                //     iframe.src = 'https://simsaleuat.ooredoo.ps/ods/IslWebAPI/ekyc/pc/ods744be4c497f488571e79960383e73a80?uniqueCode=ods-734718b72ebd2ff7845cd60b8ecf8ffa&responseCode=501&responseDesc=Aliveness%20failed&trxId=57A64D656CFC4D5CA608722653EE1489';
                                // }, 4000)

                            }

                        }

                    }).catch((err) => {
                    journeyFactory.onLivenessCheckFailed(err);
                    return err;
                });

            },
            onClose: function () {
            },

            buttons: {
                cancel: {
                    text: window.application.ods.js_trans.cancel,
                },
            }

        });
    }

    async onDataCaptureUpdated() {
        console.log('onDataCaptureUpdated', this)

        const journeyFactory = this;

        if (!journeyFactory.dataCaptureState.data_captrue.status) {
            return journeyFactory.onDataCaptureFailed(journeyFactory.dataCaptureState.data_captrue);
        }

        try {
            journeyFactory.params.onDataCaptureSuccess(journeyFactory.dataCaptureState);
        } catch (e) {
            console.error('Form Err: ', e)
        }

        journeyFactory._alertDataCapture.close();

        if (journeyFactory.disable_liveness_check) {
            // successAlert('تمت عملية التحقق من الوثيقة بنجاح. يمكنك المتابعة الآن وإتمام طلبك.', {});
            successAlert('تمت عملية التحقق بنجاح يرجى التأكد من البيانات.', {});
            return;
        }
        journeyFactory.startLivenessCheck();

    }

    onLivenessCheckUpdated() {
        const journeyFactory = this;

        if (this.dataCaptureState.liveness_check.status) {
            // successAlert('تمت عملية التحقق من الوثيقة بنجاح. يمكنك المتابعة الآن وإتمام طلبك.', {});
            successAlert('تمت عملية التحقق بنجاح يرجى التأكد من البيانات.', {});

            journeyFactory.params.onJourneyCompleted();

            if (journeyFactory._alertLivenessCheck) {
                journeyFactory._alertLivenessCheck.close();
            }
            journeyFactory._alertLivenessCheck = null;

            return;
        }


        let message = this.dataCaptureState.liveness_check.message;

        journeyFactory.onLivenessCheckFailed(this.dataCaptureState.liveness_check);


    }

    onDataCaptureFailed(err) {
        console.log('onDataCaptureFailed', err);
        console.log('onDataCaptureFailed@this', this);
        if (typeof err === 'undefined') {
            err = {};
        }

        let message = err.message || 'Identity capture cannot be done';

        const journeyFactory = this;

        const alertButtons = {};

        alertButtons.restart = {
            text: window.application.oss.translations.ekyc.try_again,
            btnClass: 'main-btn',
            action: function () {

                // journeyFactory.getUniqueId();

                journeyFactory.startJourney();

            }
        };
        alertButtons.close = {
            text: window.application.oss.translations.oss_form.close,
            btnClass: 'main-btn-outline',
            action: function () {
            }
        };

        errorAlert(message, {
            buttons: alertButtons
        });


        if (journeyFactory._alertDataCapture) {
            journeyFactory._alertDataCapture.close();
        }
        journeyFactory._alertDataCapture = null;

    }

    onLivenessCheckFailed(err) {
        console.log('onLivenessCheckFailed', err);
        console.log('onLivenessCheckFailed@this', this);
        const journeyFactory = this;
        if (typeof err === 'undefined') {
            err = {};
        }

        let message = err.message || 'Liveness cannot be done';
        const alertButtons = {};

        alertButtons.restart = {
            text: window.application.oss.translations.ekyc.try_again,
            btnClass: 'main-btn',
            action: function () {

                journeyFactory.getUniqueId();

                if (!journeyFactory.photoCaptureBaseUniqueCode) {
                    journeyFactory.photoCaptureBaseUniqueCode = journeyFactory.formConfig.photo_capture.uniqueCode;
                }

                journeyFactory.formConfig.photo_capture.uniqueCode = `${journeyFactory.photoCaptureBaseUniqueCode}${journeyFactory._uniqueId}`;
                journeyFactory.startLivenessCheck();

            }
        };
        alertButtons.close = {
            text: window.application.oss.translations.oss_form.close,
            btnClass: 'main-btn-outline',
            action: function () {
            }
        };

        errorAlert(message, {
            buttons: alertButtons
        });


        this._alertLivenessCheck.close();
        this._alertLivenessCheck = null;
    }
}